/* eslint-disable no-console */
import Rematch, { STATES } from "../model/rematch";
import api from "./api";
import routes from "./apiRoutes.json";

enum TYPES {
    ACCEPT = "ACCEPT",
    CONFIRM = "CONFIRM",
}

interface message {
    type: TYPES,
    origId: string,
}

interface redisMessage {
    id: string,
    content: string,
}


const channel = "rematch-";
const serverUrl = process.env.REACT_APP_GO;

class RedisFriendMatch {
    friendMatchSocket: WebSocket;
    friendMatchState: Rematch;
    setFriendMatchState: Function;
    setOpponentId: Function;
    setChannelId: Function;
    origId: string;
    oponnentId: string;
    categoryIds: string[];

    constructor(oponnentId: string, friendMatchState: Rematch, setFriendMatchState: Function,
        setOpponentId: Function, setChannelId: Function, origId: string, categoryIds:string[]) {
        this.oponnentId = oponnentId;
        this.friendMatchState = friendMatchState;
        this.setFriendMatchState = setFriendMatchState;
        this.setOpponentId = setOpponentId;
        this.setChannelId = setChannelId;
        this.origId = origId;
        this.categoryIds = categoryIds;

        this.friendMatchSocket = new WebSocket(`${serverUrl}${channel}${this.origId}`);

        this.friendMatchSocket.onmessage = (event) => {
            this.handleRematchMessage(event.data);
        };

    }

    createMessage = (type: TYPES): message => ({
        type: type,
        origId: this.origId || "-1",
    })

    publish = (socket: WebSocket, channel: string, type: TYPES): void => {
        const redisMessage: redisMessage = {
            id: channel,
            content: JSON.stringify(this.createMessage(type)),
        };
        socket.send(JSON.stringify(redisMessage));
    }

    parseData = (data: string): message => {
        const json: redisMessage = JSON.parse(data);
        const content: message = JSON.parse(json.content);
        return content;
    }

    sendAcceptGame = async () => {
        while (!this.friendMatchSocket.readyState) {
            await new Promise((resolve) => setTimeout(resolve, 50));
        }
        const opponentChannel = `${channel}${this.oponnentId}`;
        this.publish(this.friendMatchSocket, opponentChannel, TYPES.ACCEPT);
    }

    sendStartGame = () => {
        this.setFriendMatchState(STATES.SEND_START_GAME);
        api.post(
            routes.startGame,
            {
                player2: this.oponnentId,
                categories: this.categoryIds,
            },
        ).then((response) => {
            const channelId = response.data.data;
            this.setChannelId(channelId);
            this.setFriendMatchState(STATES.START_GAME);
        },
        ).catch((err) => {
            console.log(err);
            // this.rejectAndLook();
        });
    }

    handleRematchMessage = (data: string): void => {
        const content: message = this.parseData(data);
        console.log(content);
        if (content.origId !== this.oponnentId)
            return;
        if (content.type === TYPES.ACCEPT) {
            const opponentChannel = `${channel}${this.oponnentId}`;
            this.publish(this.friendMatchSocket, opponentChannel, TYPES.CONFIRM);
            this.setOpponentId(this.oponnentId);
            this.sendStartGame();
        } else if (content.type === TYPES.CONFIRM) {
            this.sendStartGame();
            this.setOpponentId(this.oponnentId);
        }
    };

    close = () => {
        console.log("closing rematch");
        this.friendMatchSocket.close();
    }
}


let instance: RedisFriendMatch | undefined = undefined;

const setRedisFriendMatch = (friendMatchState: Rematch): void => {
    if (instance === undefined)
        return;
    instance.friendMatchState = friendMatchState;

};

const createRedisFriendMatch = (oponnentId: string, rematchState: Rematch, setRematchState: Function,
    setOpponentId: Function, setChannelId: Function, userId: string, categoryIds: string[]): RedisFriendMatch => {
    if (instance)
        instance.close();
    instance = new RedisFriendMatch(oponnentId, rematchState, setRematchState, setOpponentId, setChannelId, userId, categoryIds);
    console.log(instance);
    return instance;
};

export { setRedisFriendMatch };


export default createRedisFriendMatch;
